import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getRooms(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.rooms;
}
